import React, { useEffect, useState } from "react";
import classnames from "classnames";
import { motion } from "framer-motion";

const CardTabs = ({ cardTabs, activeCardTab, setActiveCardTab }) => {
    const [tabs, setTabs] = useState(cardTabs);
    const [activeTab, setActiveTab] = useState(activeCardTab);

    useEffect(() => {
        setTabs(cardTabs);
        setActiveTab(activeCardTab);
    }, [activeCardTab, cardTabs]);

    return (
        <ul className="nav nav-tabs mb-2 border-bottom-0  px-1">
            {tabs?.map((item, index) => (
                <li className="nav-item" key={index}>
                    <a
                        href="#"
                        className={classnames("nav-link px-3 py-2", {
                            active: activeTab === item?.tabName,
                        })}
                        style={{ cursor: "pointer", position: "relative" }}
                        onClick={(ev) => {
                            ev.preventDefault();
                            setActiveCardTab(item?.tabName);
                        }}
                    >
                        <motion.span
                            initial={{ opacity: 0.5 }}
                            animate={{ opacity: activeTab === item?.tabName ? 1 : 0.7 }}
                            transition={{ duration: 0.25 }}
                            className="fw-semibold"
                        >
                            {item?.tabName}
                        </motion.span>

                        {/* Animated underline */}
                        {activeTab === item?.tabName && (
                            <motion.div
                                layoutId="tab-underline"
                                transition={{ type: "spring", stiffness: 500, damping: 30 }}
                                style={{
                                    position: "absolute",
                                    bottom: 0,
                                    left: 0,
                                    right: 0,
                                    height: "3px",
                                    background: "linear-gradient(90deg, #0d6efd 0%, #0dcaf0 100%)",
                                    borderRadius: "2px",
                                }}
                            />
                        )}
                    </a>
                </li>
            ))}
        </ul>
    );
};

export default CardTabs;
